import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import technology_img from './images/Technology.jpg';


export default function Technology() {
    return (
        <>

            <div className='bg-white technology-bg-img'>
                <section className="py-28" style={{ background: "linear-gradient(152.92deg, rgba(192, 132, 252, 0.2) 4.54%, rgba(232, 121, 249, 0.17) 34.2%, rgba(192, 132, 252, 0.1) 77.55%)" }}>
                    <div className="max-w-screen-xl mx-auto px-4 md:text-center md:px-8">
                        <div className="max-w-xl space-y-3 md:mx-auto">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-white text-3xl font-bold sm:text-4xl mb-2">
                                    Technology
                                </h3>
                                <p className="text-white">
                                    Technology companies in the UAE can be categorized into various sectors based on their areas
                                    of specialization and the services they provide. Here are some common categories
                                </p>
                            </ScrollAnimation>
                        </div>
                    </div>
                </section>
            </div>

            <div className='bg-white'>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                                <ScrollAnimation animateIn="fadeInLeft">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl">
                                        Software   <span style={{ color: "#1fa1cb" }}>Development :</span>
                                    </h3>
                                    <p className="mt-3  text-gray-500 font-medium">
                                        Software development companies are at the forefront of innovation, crafting diverse solutions ranging from mobile
                                        apps and web applications to enterprise software and SaaS products. With dedicated teams of skilled professionals,
                                        they conceptualize, design, develop, and deploy custom solutions to address specific client requirements.
                                        These companies play a pivotal role in driving digital transformation and empowering businesses to thrive in an increasingly
                                        competitive landscape. Through their expertise and commitment to excellence, they enable organizations to streamline operations,
                                        enhance efficiency, and deliver exceptional user experiences.
                                    </p>
                                </ScrollAnimation>
                            </div>
                            <div className="flex-1 sm:hidden lg:block">
                                <ScrollAnimation animateIn="fadeInRight">
                                    <img src={technology_img} className="md:max-w-lg sm:rounded-lg" alt="Technology-img" />
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className='bg-blue-50' style={{ paddingTop: 30, paddingBottom: 40 }}>
                <section className="py-2 pt-5" style={{ paddingTop: 50 }}>
                    <div className="max-w-screen-xl mx-auto px-4  gap-x-12 justify-between md:flex md:px-8">
                        <div className="max-w-xxl">
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className="text-gray-600 text-3xl font-bold sm:text-2xl pb-1">
                                    <span style={{ color: "#1fa1cb" }}> Telecommunications :</span>
                                </h3>
                            </ScrollAnimation>
                            <p className="mt-5 text-gray-500 font-medium">
                                Telecom companies providing internet, mobile, and
                                landline services, as well as infrastructure development for telecommunications
                                networks.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                IT Services and Consulting :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Firms offering IT consulting, system integration, network infrastructure setup, cybersecurity services, and IT support.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                E-commerce and Online Marketplaces :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Companies operating online retail platforms, marketplaces, and e-commerce solutions, facilitating online buying and selling.
                            </p>
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                    Hardware <span style={{ color: "#1fa1cb" }}> Manufacturing :</span>
                                </h3>
                            </ScrollAnimation>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                This is where we come into the picture. At Dubai Setup, we have a track record of matching companies with the right Local Partner. Our business setup experts are all informed of the latest changes in legislation and can tell you that if you are a professional planning to offer professional services*, then what you need is a Local Service Agent and not a Local Partner.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                Fintech :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Financial technology companies focusing on digital payment solutions,
                                blockchain technology, peer-to-peer lending, crowdfunding platforms, and other
                                innovative financial services.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                Health-tech :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Companies specializing in healthcare technology, including
                                electronic health records (EHR), telemedicine platforms, medical device
                                manufacturing, and health analytics.
                            </p>
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                    Artificial Intelligence  <span style={{ color: "#1fa1cb" }}>and Machine Learning : </span>
                                </h3>
                            </ScrollAnimation>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Organizations developing AI and
                                ML algorithms, applications, and platforms for various industries such as finance,
                                healthcare, retail, and transportation.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                Renewable Energy Technology :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Companies engaged in developing and
                                implementing renewable energy solutions, including solar power, wind energy,
                                and energy management systems.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                Space Technology :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Emerging sector focusing on satellite technology, space
                                exploration, satellite communication, and satellite imagery analysis.
                            </p>
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                    Robotics and <span style={{ color: "#1fa1cb" }}>Automation : </span>
                                </h3>
                            </ScrollAnimation>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Companies involved in developing robotics solutions
                                for industrial automation, logistics, manufacturing, and service sectors.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                Cybersecurity :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Specialized firms offering cybersecurity solutions, including threat
                                detection, vulnerability assessments, penetration testing, and security consulting
                                services.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                Edtech :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Companies providing educational technology solutions, including elearning platforms, online courses, virtual classrooms, and educational software.
                            </p>
                            <ScrollAnimation animateIn="fadeIn">
                                <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                    <span style={{ color: "#1fa1cb" }}>Agritech :</span>
                                </h3>
                            </ScrollAnimation>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Tech companies focusing on agricultural technology, including
                                precision farming, crop monitoring, agricultural drones, and farm management
                                software.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5">
                                Blockchain and Cryptocurrency :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Entities working on blockchain technology,
                                cryptocurrency exchanges, digital asset management, and blockchain-based
                                applications.
                            </p>
                            <h3 className=" text-gray-600 text-3xl font-bold sm:text-2xl mt-5 ">
                                Augmented Reality (AR) and Virtual Reality (VR) :
                            </h3>
                            <p className="mt-5 text-gray-500 font-medium" style={{ lineHeight: 2 }}>
                                Companies developing AR and VR solutions
                                for gaming, entertainment, education, training, and enterprise applications.
                            </p>
                            <h3 className="mt-5 text-gray-500 text-1xl font-bold sm:text-1xl mb-5" style={{ lineHeight: 2, fontSize: 20 }}>
                                These categories represent the diverse range of technology companies operating in the
                                UAE, contributing to the country's technological advancement and economic growth.
                            </h3>
                        </div>
                    </div>
                </section>
            </div>

            <div className='mb-5'>
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto md:px-8">
                        <div className="items-center gap-x-12 sm:px-4 md:px-0 lg:flex">
                            <div className="flex-1 sm:hidden lg:block" style={{ marginBottom: 200 }}>
                                <div className="fb-iframe-container">
                                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fweb.facebook.com%2Fdubaisetupinfo.co&tabs=timeline&width=340&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                                        width="1240" height="500" className='fb-frame' style={{ border: 'none', overflow: 'hidden' }} scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                                </div>
                            </div>
                            <div className="max-w-xl px-4 space-y-3 mt-6 sm:px-0 md:mt-0 lg:max-w-2xl">
                                <div className="fb-container-text">
                                    <h3 className="text-gray-600 text-3xl font-bold sm:text-4xl mb-5">
                                        Dubai Setup  <span className="text-customLightBlue">Facebook Page</span>
                                    </h3>
                                    <p className="text-gray-900 text-1xl font-normal sm:text-1xl ">
                                        This company's Facebook page is a testament to their dedication to excellence, fostering a vibrant community, and showcasing their creativity. With captivating content and interactive engagement, they go beyond mere promotion, building genuine connections with their audience. Each post tells a story, evoking emotions and leaving a lasting impression on followers. Their commitment to innovation shines through in every aspect of their page, setting them apart from the competition. Moreover, they prioritize customer satisfaction, ensuring transparency and authenticity in all interactions. Their page serves as a window into their values and aspirations, inspiring trust and loyalty among their followers. Overall, this company's Facebook presence embodies their passion for making a difference and leaves a lasting impact on all who engage with it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div className="container-fluid main-freezone-contact-img main-freezone-contact">
                <section className="py-14">
                    <div className="max-w-screen-xl mx-auto px-4 md:px-8">
                        <div className="max-w-xl">
                            <h3 className="text-5xl font-bold text-white mb-5" style={{ letterSpacing: 1 }}>
                                Have a question?<br></br>
                                Get in touch today
                            </h3>
                            <p className="text-white mt-5 font-semibold" style={{ marginTop: 30 }}>
                                Our experts are always available to answer your queries.
                            </p>
                            <a href="https://wa.me/+971562657300" target='_blank' rel="noreferrer">
                                <button class="whatsapp-btn" style={{ marginTop: 30 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" id="IconChangeColor" height="25" width="25"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" id="mainIconPathAttribute" fill="#ffffff"></path></svg>
                                    WhatsApp
                                </button>
                            </a>

                            <a href="tel:+971562657300" >
                                <button class="phone-number" style={{ marginTop: 30 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="grey" class="bi bi-telephone" viewBox="0 0 16 16" id="IconChangeColor">
                                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" id="mainIconPathAttribute"></path>
                                    </svg>
                                    +971 56 265 7300
                                </button>
                            </a>


                        </div>
                    </div>
                </section>
            </div>



        </>
    )
}
